import React from 'react';
import ReactDOM from 'react-dom/client';
import './api/http';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
